<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card no-body :bg-variant="isDark ? 'gray-700' : 'white'">
          <b-row>
            <b-col sm="6" lg="4">
              <b-row class="mt-2 mb-2 mr-2 ml-2">
                <b-col sm="6">
                  <small class="text-muted">dashboard</small><br>
                  <strong class="h4">Ranking de Vendedores</strong>
                </b-col>
              </b-row>
              <hr class="ml-2 mt-0">
            </b-col>

          </b-row>
        </b-card>
      </b-col>
    </b-row>

    <!-- Carrossel -->
    <div class="carrossel-container ml-2 mr-2">
      <CarrosselVendedores
        :vendedores="vendedores"
        :selected-id="vendedor && vendedor.id"
        :is-dark="isDark"
        @abrir-detalhes="onSelecionarVendedor"
      />
    </div>

    <!-- Indicadores -->
    <div>
      <IndicadoresVendas
        :valor-total="totalVendas"
        :valor-meta="metaVendas"
        :areceber-vencidos="areceberVencidos"
        :vendas-pendentes="qtdVendasPendentes"
        :valor-comissao="valorComissaoVendedor"
      />
    </div>
    <b-row>
      <b-col md="12">
        <b-card no-body :bg-variant="isDark ? 'gray-700' : 'white'">
          <b-row class="p-2">
            
                <b-col cols="auto">
                  <b-form-input type="date" id="dt1" ref="dt1"
                                v-model="dt1" @keydown.enter="carregarVendedores()" class="bg-white"
                                placeholder="Informe a data Início"/>
                </b-col>
                <b-col cols="auto">
                  <b-form-input type="date" id="dt2"
                                v-model="dt2" @keydown.enter="carregarVendedores()" class="bg-white"
                                placeholder="Informe a data Término"/>
                </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
   <b-row>
    <!-- gráfico de linhas (já existente) -->
    <b-col sm="12" lg="8">
      <b-card>
        <b-card-title>
          <div class="d-flex justify-content-between align-items-center">
            <div>Vendas no Período</div>
          </div>
        </b-card-title>

        <b-overlay :show="graficoLinhas.isBusy" rounded="sm">
          <div style="position: relative; height: 200px;">
            <grafico-linhas-vendas-vendedor
              :dt1="dt1"
              :dt2="dt2"
              :vendedor-id="vendedor ? vendedor.id : ''"
              @busy="graficoLinhas.isBusy = $event"
              @abrir-modal="abrirModal"
            />
          </div>
        </b-overlay>
      </b-card>
    </b-col>

    <!-- NOVO: gráfico de barras mensal com linha de meta à direita -->
    <b-col sm="12" lg="4">
      <b-card>
        <b-card-title class="d-flex justify-content-between align-items-center">
          <div>Vendas por Mês</div>
        </b-card-title>

        <b-overlay :show="graficoBarras.isBusy" rounded="sm">
          <div style="position: relative; height: 200px;">
            <grafico-barras-vendas-mensal-vendedor
              :dt1="dt1"
              :dt2="dt2"
              :vendedor-id="vendedor ? vendedor.id : ''"
              :meta-mensal="metaVendas"
              @busy="graficoBarras.isBusy = $event"
            />
          </div>
        </b-overlay>
      </b-card>
    </b-col>
  </b-row>

  <b-row class="mt-3">
    <!-- NOVO: Ranking de Comissões -->
    <b-col md="12">
      <b-card>
        <b-card-title class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <span class="mr-3">Ranking de Comissões dos Vendedores</span>
            <b-form-checkbox v-model="soQuitados" name="check-button" switch @change="carregarVendedores()">
              <small :class="soQuitados ? 'text-success font-weight-bold' : 'text-muted'">Apenas Quitados</small>
            </b-form-checkbox>
          </div>
          <div class="text-info small">Total Comissões: {{ formatBRL(totalComissao) }}</div>
        </b-card-title>

        <div style="position: relative; height: 260px; margin-top: 20px;">
          <grafico-comissoes-vendedores
            :vendedores="vendedores"
            @abrir-detalhes-comissao="abrirDetalhesComissao"
          />
        </div>
      </b-card>
    </b-col>
  </b-row>

  <!-- Modal Detalhes Comisso - Padrão Premium -->
  <b-modal
    id="modal-detalhes-comissao"
    v-model="modalComissao.show"
    size="xl"
    scrollable
    centered
    hide-footer
    header-bg-variant="primary"
    header-text-variant="light"
    body-class="p-0"
    modal-class="premium-modal"
  >
    <template #modal-title>
      <div class="d-flex align-items-center">
        <i class="fas fa-percentage mr-2"></i>
        <div>
          <span class="text-uppercase font-weight-bold">Detalhamento de Comissões</span>
          <br />
          <small class="text-light opacity-75">{{ modalComissao.vendedorNome }} | Período: {{ formatDataBR(dt1) }} - {{ formatDataBR(dt2) }}</small>
          <b-badge v-if="soQuitados" variant="success" pill class="ml-2 py-1 px-2 border border-white-50 shadow-sm" style="font-size: 0.65rem; vertical-align: middle;">
            <i class="fas fa-check-circle mr-1"></i> APENAS QUITADOS
          </b-badge>
        </div>
      </div>
    </template>

    <div class="p-3 bg-light border-bottom">
      <b-row>
        <b-col md="4">
          <b-card class="border-0 shadow-sm mb-0 bg-white">
            <div class="d-flex align-items-center">
              <div class="rounded-circle bg-info-light p-3 mr-3">
                <i class="fas fa-shopping-cart text-info"></i>
              </div>
              <div>
                <small class="text-muted text-uppercase d-block mb-1">Total Bruto</small>
                <h4 class="mb-0 font-weight-bold">{{ formatBRL(calcularTotalBrutoModal()) }}</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card class="border-0 shadow-sm mb-0 bg-white">
            <div class="d-flex align-items-center">
              <div class="rounded-circle bg-success-light p-3 mr-3">
                <i class="fas fa-coins text-success"></i>
              </div>
              <div>
                <small class="text-muted text-uppercase d-block mb-1">Comissão Estimada</small>
                <h4 class="mb-0 text-success font-weight-bold">{{ formatBRL(modalComissao.totalGeral) }}</h4>
              </div>
            </div>
          </b-card>
        </b-col>
        <b-col md="4">
          <b-card class="border-0 shadow-sm mb-0 bg-white">
            <div class="d-flex align-items-center">
              <div class="rounded-circle bg-warning-light p-3 mr-3">
                <i class="fas fa-list-ol text-warning"></i>
              </div>
              <div>
                <small class="text-muted text-uppercase d-block mb-1">Itens Vendidos</small>
                <h4 class="mb-0 font-weight-bold">{{ modalComissao.linhas.length }}</h4>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <div class="p-4">
      <b-overlay :show="modalComissao.loading" rounded="sm" opacity="0.6">
        <b-table
          small
          hover
          striped
          responsive
          show-empty
          head-variant="light"
          :items="modalComissao.linhas"
          :fields="modalComissao.fields"
          empty-text="Nenhuma venda encontrada para este vendedor no período."
          class="mb-0 border rounded overflow-hidden"
        >
          <template #cell(N_VENDA)="data">
            <b-badge variant="light" class="p-2 border">{{ data.item.N_VENDA }}</b-badge>
          </template>
          
          <template #cell(NOME_CLIENTE)="data">
            <div class="text-truncate" style="max-width: 200px;" v-b-tooltip.hover :title="data.item.NOME_CLIENTE">
              {{ data.item.NOME_CLIENTE }}
            </div>
          </template>

          <template #cell(NOME_PRODUTO)="data">
            <div>
              <span class="d-block font-weight-bold">{{ data.item.NOME_PRODUTO }}</span>
              <small class="text-muted">{{ data.item.NOME_GRUPO }}</small>
            </div>
          </template>

          <template #cell(VL_TOTAL_BRUTO)="data">
            <span class="font-weight-bold">{{ formatBRL(data.item.VL_TOTAL_BRUTO) }}</span>
          </template>

          <template #cell(PERCENTUAL_COMISSAO)="data">
            <b-badge pill variant="secondary" class="px-2">{{ data.item.PERCENTUAL_COMISSAO }}%</b-badge>
          </template>

          <template #cell(VALOR_COMISSAO)="data">
            <span class="text-success font-weight-bold">{{ formatBRL(data.item.VALOR_COMISSAO) }}</span>
          </template>
        </b-table>
      </b-overlay>
    </div>

    <div class="p-3 bg-light text-right border-top">
      <b-button variant="outline-secondary" rounded-pill class="px-4" @click="modalComissao.show = false">Fechar</b-button>
      <b-button variant="info" rounded-pill class="px-4 ml-2" @click="abrirAnaliseGerencial()">
        <i class="fas fa-chart-pie mr-1"></i> Análise Gerencial
      </b-button>
      <b-button variant="primary" rounded-pill class="px-4 ml-2" @click="exportarComissaoCSV()">
        <i class="fas fa-file-excel mr-1"></i> Exportar
      </b-button>
    </div>
  </b-modal>

  <relatorio-comissao-vendedor-modal
    :dt1="dt1"
    :dt2="dt2"
    :vendedor-id="modalComissao.vendedorId || ''"
    :vendedor-nome="modalComissao.vendedorNome"
    :dados="modalComissao.linhas"
    :so-quitados="soQuitados"
  />

    <b-row class="mt-3">
      <b-col md="12">
        <b-card>
          <b-card-title class="d-flex justify-content-between align-items-center">
            <div>Clientes atendidos no período</div>
            <div class="text-muted small">
              Top {{ graficoClientes.top }} (clique em um cliente para detalhes)
            </div>
          </b-card-title>

          <b-overlay :show="graficoClientes.isBusy" rounded="sm">
            <grafico-barras-clientes-vendedor
              style="height:260px;margin-top:20px;"
              :dt1="dt1"
              :dt2="dt2"
              :vendedor-id="vendedor ? vendedor.id : ''"
              :top="graficoClientes.top"
              @busy="graficoClientes.isBusy = $event"
              @abrir-cliente="abrirCliente"
            />
          </b-overlay>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-cliente-vendas"
      :title="modalCliente.nome || 'Cliente'"
      size="xl"
      v-model="modalCliente.show"
      scrollable
      centered
      hide-footer
    >
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <b-badge variant="primary" class="mr-2">Cliente ID: {{ modalCliente.clienteId }}</b-badge>
          <b-badge variant="info" class="mr-2">Vendedor ID: {{ vendedor && vendedor.id }}</b-badge>
          <b-badge variant="success" class="mr-2">Total: {{ formatBRL(modalCliente.resumo.valor) }}</b-badge>
          <b-badge variant="warning">Qt. Vendas: {{ modalCliente.resumo.qtVendas }}</b-badge>
        </div>
        <div>
          <b-button size="sm" variant="outline-secondary" @click="exportarCSVCliente()">Exportar CSV</b-button>
          <b-button class="ml-2" size="sm" variant="outline-secondary" @click="exportarHtml()">Imprimir</b-button>
          <b-button class="ml-2" size="sm" variant="outline-secondary" @click="exportarExcel()">Excel</b-button>
        </div>
      </div>

      <b-overlay :show="modalCliente.loading" rounded="sm">
        <b-table
          small
          hover
          striped
          head-variant="light"
          :items="modalCliente.linhas"
          :fields="modalCliente.fields"
          :per-page="modalCliente.perPage"
          :current-page="modalCliente.page"
        >
          <template #cell(valor)="{ item }">
            {{ formatBRL(item.valor) }}
          </template>
          <template #cell(totalNfe)="{ item }">
            {{ formatBRL(item.totalNfe) }}
          </template>
          <template #cell(dt)="{ item }">
            {{ formatDataBR(item.dt) }}
          </template>
        </b-table>

        <b-pagination
          v-if="modalCliente.linhas.length > modalCliente.perPage"
          v-model="modalCliente.page"
          :per-page="modalCliente.perPage"
          :total-rows="modalCliente.linhas.length"
          align="right"
          size="sm"
          class="mt-2"
        />
      </b-overlay>
    </b-modal>

  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import CarrosselVendedores from './CarrosselVendedores.vue'
import IndicadoresVendas from './IndicadoresVendas.vue'
import GraficoLinhasVendasVendedor from './GraficoLinhasVendasVendedor.vue'
import GraficoBarrasVendasMensalVendedor from './GraficoBarrasVendasMensalVendedor.vue'
import GraficoBarrasClientesVendedor from './GraficoBarrasClientesVendedor.vue'
import GraficoComissoesVendedores from './GraficoComissoesVendedores.vue'
import RelatorioComissaoVendedorModal from './RelatorioComissaoVendedorModal.vue'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';

export default {
  name: 'VendasPeriodo',
  components: {
    CarrosselVendedores,
    IndicadoresVendas,
    GraficoLinhasVendasVendedor,
    GraficoBarrasVendasMensalVendedor,
    GraficoBarrasClientesVendedor,
    GraficoComissoesVendedores,
    RelatorioComissaoVendedorModal
  },
  data () {
    return {
      dt1: new Date().toISOString().substr(0, 10),
      dt2: new Date().toISOString().substr(0, 10),
      vendedores: [],
      vendedor: null,                 // selecionado no carrossel
      graficoLinhas: { isBusy: false },
      graficoBarras: { isBusy: false },
      graficoClientes: { isBusy: false, top: 12 },
      soQuitados: false,

      // mock dos indicadores (trocar pelos reais quando quiser)
      totalVendas: 0,
      metaVendas: 0,
      areceberVencidos: 0,
      qtdVendasPendentes: 0,
      totalComissao: 0,
      valorComissaoVendedor: 0,

      modalComissao: {
        show: false,
        loading: false,
        vendedorNome: '',
        vendedorId: null,
        totalGeral: 0,
        linhas: [],
        fields: [
          { key: 'N_VENDA', label: 'Nº Venda', sortable: true },
          { key: 'DT_SAIDA', label: 'Data', sortable: true, formatter: v => new Date(v).toLocaleDateString('pt-BR') },
          { key: 'NOME_CLIENTE', label: 'Cliente', sortable: true },
          { key: 'NOME_PRODUTO', label: 'Produto', sortable: true },
          { key: 'VL_TOTAL_BRUTO', label: 'Vl. Bruto', sortable: true, class: 'text-right' },
          { key: 'PERCENTUAL_COMISSAO', label: '% Com.', sortable: true, class: 'text-center' },
          { key: 'VALOR_COMISSAO', label: 'Comissão', sortable: true, class: 'text-right' }
        ]
      },

      busy: false,
      currentPage: 0,
      modalCliente: {
       show: false,
       loading: false,
       clienteId: null,
       nome: '',
       resumo: { valor: 0, qtVendas: 0 },
       linhas: [],
       page: 1,
       perPage: 10,
       // defina os campos que quer ver no b-table:
       fields: [
         { key: 'numero', label: 'Nº', sortable: true },
         { key: 'cliente', label: 'Cliente', sortable: true },
         { key: 'itens', label: 'Itens', sortable: true },
         { key: 'dt', label: 'Data', sortable: true, type:'date' },
         { key: 'totalNfe', label: 'Valor', sortable: true, class: 'text-right', type:'currency',  },
         { key: 'situacao', label: 'Situação', sortable: true }
       ]
     }
    }
  },
  computed: {
    isDark () { return this.$store.getters['tema/IS_DARK'] }
  },
  methods: {
    formatBRL (v) {
       return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    formatDataBR (iso) {
      const d = new Date(iso); return isNaN(d) ? '' : d.toLocaleDateString('pt-BR')
    },
    onSelecionarVendedor (v) {
      this.vendedor = v
      // o gráfico atualiza sozinho pelo watch(vendedorId) no componente filho

      this.totalVendas = v.valorTotal
      this.metaVendas = v.meta
      this.areceberVencidos = v.areceberVencidos
      this.qtdVendasPendentes = v.titulosVencidos
      this.valorComissaoVendedor = v.valorComissao
    },
    async abrirDetalhesComissao(payload) {
      this.modalComissao.vendedorId = payload.vendedorId
      this.modalComissao.vendedorNome = payload.nome
      this.modalComissao.totalGeral = payload.totalComissao
      this.modalComissao.show = true
      this.modalComissao.loading = true
      this.modalComissao.linhas = []

      try {
        const { data } = await this.$http.get('/api/protected/venda/getDetalhesComissaoVendedor', {
          params: {
            dt1: this.dt1,
            dt2: this.dt2,
            vendedorId: payload.vendedorId,
            soQuitados: this.soQuitados
          }
        })
        this.modalComissao.linhas = Array.isArray(data) ? data : []
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar os detalhes da comissão', 'danger', error)
      } finally {
        this.modalComissao.loading = false
      }
    },
    calcularTotalBrutoModal() {
      return this.modalComissao.linhas.reduce((acc, curr) => acc + (curr.VL_TOTAL_BRUTO || 0), 0)
    },
    exportarComissaoCSV() {
      if (!this.modalComissao.linhas || this.modalComissao.linhas.length === 0) return
      
      const colunas = [
        { label: 'Venda', key: 'N_VENDA' },
        { label: 'Data', key: 'DT_SAIDA', type: 'date' },
        { label: 'Cliente', key: 'NOME_CLIENTE' },
        { label: 'Grupo', key: 'NOME_GRUPO' },
        { label: 'Produto', key: 'NOME_PRODUTO' },
        { label: 'Valor Bruto', key: 'VL_TOTAL_BRUTO', type: 'currency' },
        { label: '% Com.', key: 'PERCENTUAL_COMISSAO', type: 'percent' },
        { label: 'Vl. Com.', key: 'VALOR_COMISSAO', type: 'currency' }
      ]
      
      exportCsv({
        filename: `Comissoes_${this.modalComissao.vendedorNome}_${this.dt1}_${this.dt2}.csv`,
        columns: colunas,
        rows: this.modalComissao.linhas
      })
    },
    abrirAnaliseGerencial() {
      this.$bvModal.show('modal-relatorio-comissao')
    },
    abrirModal ({ dia, tipo }) {
      // abra seu modal/tabela detalhada
      console.log('abrirModal(VendasPeriodo):', dia, tipo)
      // exemplo:
      // this.$bvModal.show('modal-vendas-dia')
    },
    async abrirCliente ({ clienteId, nome, valor, qtVendas }) {
      this.modalCliente.show = true
      this.modalCliente.loading = true
      this.modalCliente.clienteId = clienteId
      this.modalCliente.nome = nome
      this.modalCliente.resumo = { valor, qtVendas }
      this.modalCliente.page = 1
      
      try {
        // 🔎 TENTE buscar os pedidos/notas desse cliente
        // Ajuste o endpoint para o que você tiver disponível no backend.
        // Sugestão de rota: /api/protected/venda/getPedidosClienteVendedorId
        // params: { dt1, dt2, vendedorId, clienteId }
        const vendedorId = this.vendedor ? this.vendedor.id : null
        const situacao = '1'
        const { data } = await this.$http.get('/api/protected/vendapedido/pesquisar', {
          params: { dt1: this.dt1, dt2: this.dt2, vendedorId, clienteId, situacao }
        })
        const rows = Array.isArray(data) ? data : (data?.data || [])
      
        // mapeie para os campos da tabela
        this.modalCliente.linhas = rows.map(r => ({
          numero: r.N_VENDA || '',
          cliente: r.NOME_CLIENTE || '',
          itens:  r.ITENS_VENDA  || r.serie  || '',
          dt:     r.DT_SAIDA || null,
          totalNfe: Number(r.VL_TOTAL_NFE  ?? 0),
          situacao: r.SITUACAO_TRADUZIDO || ''
        }))
      
        // fallback: se não vier nada, pelo menos mostre o agregado numa linha
        if (!this.modalCliente.linhas.length) {
          this.modalCliente.linhas = [{
            numero: '—',
            itens: '-',
            cliente: '-',
            dt: this.dt1,
            totalNfe: valor,
            situacao: `Total do período (${qtVendas} venda(s))`
          }]
        }
      } catch (e) {
        // Se o endpoint não existir ainda, mostre só o agregado
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar as notas do cliente (mostrando resumo)', 'warning', e)
        this.modalCliente.linhas = []
      } finally {
        this.modalCliente.loading = false
      }
    },
    formatar(valor) {
      return valor?.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) ?? '0,00'
    },
    formatBRL(v) {
      return Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    exportarCSVCliente () {
      if (!this.modalCliente.linhas || this.modalCliente.linhas.length === 0) return
      
      exportCsv({
        filename: `vendas_cliente_${this.modalCliente.clienteId}_${this.dt1}_${this.dt2}.csv`,
        columns: this.modalCliente.fields,
        rows: this.modalCliente.linhas
      })
    },
    exportarHtml () {
      printHtmlReport({
        rows: this.modalCliente.linhas || [],                 // seu array de dados
        columns: this.modalCliente.fields,
        systemName: 'CECWeb',
        reportTitle: `Vendas - Vendedor: ${this.vendedor && this.vendedor.nome} Cliente: ${this.modalCliente.clienteId} - ${Tools.formatarDataBR(this.dt1)} - ${Tools.formatarDataBR(this.dt2)}`,
        printedBy: window.localStorage.getItem('login') ?? '—',
        observations: this.modalCliente.nome || 'Cliente',
        pageSize: 'A4',
        landscape: true,                    // vira “deitado” se quiser
        footerTotals: [
          // soma só a coluna DEBITO (usa key da coluna)
          { key:'totalNfe', formatter: v => v.toLocaleString('pt-BR',{style:'currency',currency:'BRL'}) }
        ],
      });
    },
    exportarExcel(){
      exportExcelXlsx ({
        rows: this.modalCliente.linhas || [],
        columns: this.modalCliente.fields,
        filename: `vendas_cliente_${this.modalCliente.clienteId}_${this.dt1}_${this.dt2}.xls`,
         sumKey: 'totalNfe'              // mesma key da sua coluna de Débito (soma no rodapé)
      });
    },
    
    async carregarVendedores () {
      try {
        this.currentPage = 0
        this.busy = true
        
        const { data } = await this.$http.get('/api/protected/venda/getVendasMesTodosVendedores', {
          params: { dt1: this.dt1, dt2: this.dt2, soQuitados: this.soQuitados }
        })
        const rows = Array.isArray(data) ? data : []

        this.vendedores = rows.map((r, idx) => ({
          id: r.VENDEDOR_ID,
          nome: r.NOME_VENDEDOR,
          avatar: `https://i.pravatar.cc/100?img=${((idx % 70) + 1)}`,
          vendas: Number(r.VENDAS) || 0,
          valorTotal: Number(r.VL_TOTAL) || 0,
          meta: Number(r.VL_META) || 0,
          areceberVencidos: Number(r.VL_ARECEBER_VENCIDOS) || 0,
          titulosVencidos: Number(r.TITULOS_ARECEBER_VENCIDOS) || 0,
          areceberAVencer: Number(r.VL_ARECEBER_AVENCER) || 0,
          titulosAVencer: Number(r.TITULOS_ARECEBER_AVENCER) || 0,
          valorComissao: Number(r.VL_COMISSAO) || 0
        }))

        this.totalComissao = this.vendedores.reduce((acc, v) => acc + v.valorComissao, 0)

        // define um vendedor inicial (opcional)
        if (!this.vendedor && this.vendedores.length) {
          this.vendedor = this.vendedores[0]
          this.onSelecionarVendedor(this.vendedor)
        } else if (this.vendedor) {
          // atualiza o vendedor selecionado com os novos dados
          const atualizado = this.vendedores.find(v => v.id === this.vendedor.id)
          if (atualizado) this.onSelecionarVendedor(atualizado)
        }
      } catch (error) {
        Tools.exibirMensagem(this.$store, 'Não foi possível buscar os dados', 'danger', error)
        this.vendedores = []
        this.vendedor = null
      } finally {
        this.busy = false
      }
    }
  },
  watch: {
    async dt1 () { await this.carregarVendedores() },
    async dt2 () { await this.carregarVendedores() }
  },
  async created () {
    await this.carregarVendedores()
  }
}
</script>

<style scoped>
.carrossel-container {
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}

.bg-info-light { background-color: rgba(0, 184, 212, 0.1); }
.bg-success-light { background-color: rgba(0, 200, 83, 0.1); }
.bg-warning-light { background-color: rgba(255, 171, 0, 0.1); }

.opacity-75 { opacity: 0.75; }
</style>

<style>
/* Global styles for Premium Modals */
.premium-modal .modal-content {
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.premium-modal .modal-header {
  border: none !important;
  padding: 1.5rem 2rem !important;
  background: linear-gradient(135deg, #3a7bd5 0%, #00d2ff 100%) !important;
}

.premium-modal .modal-title {
  width: 100%;
}

.premium-modal .modal-body {
  background-color: #f8fafc !important;
}

.premium-modal .table {
  background: white;
}

.premium-modal .table thead th {
  border-top: none;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  color: #64748b;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/views/dashboard/VendasPeriodo.vue